<script>
  import { _ } from 'svelte-i18n'
  import { createEventDispatcher } from 'svelte'
  import { user_saved_selections } from '../stores'
  import { toTitleCase } from '../modules/toTitleCase'
  import Button from '../elements/Button.svelte'
  
  export let is_editing = false
  export let selected_selection
  export let is_showing_history = false

  let selected_to_delete;

  const dispatch = createEventDispatcher()
  
  const handleSelect = (selection) => {
    if (is_editing) return
    dispatch("selectionSelect", selection)
  }

  const handleDelete = (selection_id) => {
    dispatch("selectionDelete", selection_id)
  }
  
  const wordmarkWithCharCase = (selection) => {
    if (selection.char_case === "AA") return (selection.wordmark.toUpperCase())
    else if (selection.char_case === "aa") return (selection.wordmark.toLowerCase())
    else if (selection.char_case === "Aa") return (toTitleCase(selection.wordmark))
    else return (selection.wordmark)
  }

  const gatherDetails = (selection) => {
    let details = ""
    if (!!selection.font_names) details += selection.font_names.split("|-|").length + " fonts, "
    if (selection.font_scale > 2) details += "big, "
    if (selection.font_scale < 2) details += "small, "
    if (selection.tracking !== 0 && selection.tracking > 0) details += "loosely spaced, "
    if (selection.tracking !== 0 && selection.tracking < 0) details += "tightly spaced, "
    // if (selection.line_space !== 4) details += "spaced, "
    if (selection.sort_order === "ascending") details += "A to Z sorted"
    if (selection.sort_order === "descending") details += "Z to A sorted"
    if (selection.sort_order === "random") details += "randomly sorted"
    return details
  }

  const formattedSaveDate = (save_date) => {
    return new Intl.DateTimeFormat("en", {dateStyle: "long", timeStyle: "short"}).format(new Date(save_date))
  }
</script>

<div class="header row">
  <h4>ENTRY</h4>
  <h4>DETAILS</h4>
  {#if is_editing}
    <h4>ACTIONS</h4>
  {:else}
    <h4>DATE SAVED</h4>
  {/if}
</div>
<div class="body">
  {#each $user_saved_selections || [] as saved_selection}
    {#if saved_selection.autosave == is_showing_history}
      <div 
      class="row" 
      class:selected={selected_selection === saved_selection}
      class:is_editing 
      on:click={() => handleSelect(saved_selection)}>
        <span>{wordmarkWithCharCase(saved_selection)}</span>
        <span>{gatherDetails(saved_selection)}</span>
        {#if is_editing}
          {#if selected_to_delete === saved_selection.id}
            <span class="confirm">
              Are you sure?
              <Button size="tiny" kind="delete" scaled_in on:click={() => handleDelete(saved_selection.id)}>Delete</Button>
              <Button size="tiny" kind="outline" scaled_in on:click={() => selected_to_delete = undefined}>Cancel</Button>
            </span>
          {:else}
            <span>
              <Button size="tiny" kind="default" danger scaled_in on:click={() => selected_to_delete = saved_selection.id}>Delete</Button>
            </span>
          {/if}
        {:else}
          <span>{formattedSaveDate(saved_selection.saved_at)}</span>
        {/if}
      </div>
    {/if}
  {/each}
</div>


<style>
  .body {
    max-height: 34rem;
    overflow-y: scroll;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 4rem;
    padding: 0 1rem;
    border-radius: 1rem;
    font-variant: lining-nums;
    transition: all var(--transition-props);
  }
  .row:not(.header):nth-of-type(odd){
    background-color: var(--c-bg);
  }
  .row:not(.header):not(.is_editing):hover {
    cursor: pointer;
    background-color: var(--c-pill-bg-hover);
  }
  .row.is_editing:not(.header):hover {
    background-color: var(--c-danger-hover);
  }
  .row.selected {
    background-color: var(--c-pill-bg-active) !important;
    color: var(--c-text-on-fill);
  }
  .row span,
  .row h4 {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 4rem;
  }
  .row span,
  .row h4 {
    width: 30%;
  }
  .row span:nth-child(2),
  .row h4:nth-child(2) {
    width: 40%;
  }
  .row span:last-child,
  .row h4:last-child {
    text-align: right;
  }
  .row span.confirm {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: flex-end;
    color: var(--c-danger);
    font-weight: bold;
  }
</style>